import { render, staticRenderFns } from "./pec.vue?vue&type=template&id=1ddb849a&scoped=true"
import script from "./pec.vue?vue&type=script&lang=js"
export * from "./pec.vue?vue&type=script&lang=js"
import style0 from "./pec.vue?vue&type=style&index=0&id=1ddb849a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb849a",
  null
  
)

export default component.exports